import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import EventWebinarDetailsContent from "./EventWebinarDetailsContent";
import EventWebinarDetailsSidebar from "./EventWebinarDetailsSidebar";
const EventsWebinarsDetails = (props) => {
    return (_jsx("div", { className: "event-webinar-details", children: _jsxs("div", { className: "event-webinar-details-wrapper", children: [_jsx("main", { children: _jsx(EventWebinarDetailsContent, { ...props }) }), _jsx(EventWebinarDetailsSidebar, { registrationCard: props.registrationCard, disablePrintAndShare: props.disablePrintAndShare, socialMediaButtons: props.socialMediaButtons })] }) }));
};
export default EventsWebinarsDetails;
